<template>
  <v-menu
    ref="date_picker_menu"
    v-model="date_picker_menu"
    :close-on-content-click="false"
    :return-value.sync="model"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="model"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        outlined
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="model"
      no-title
      scrollable
      :min="new Date().toISOString().substr(0, 10)"
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="date_picker_menu = false"
      >
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="$refs.date_picker_menu.save(model)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'GenericDatePicker',
  props: {
    model: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'N/A',
      required: false,
    },
  },
  data: () => ({
    date_picker_menu: false,
  }),
};
</script>

<style scoped>

</style>
